import * as Sentry from '@sentry/browser';
import {Integrations} from '@sentry/tracing';
import Auth from './auth';
import {
  SENTRY_DEBUG_MODE, SENTRY_DSN, SENTRY_ENV, SENTRY_TRACES_SAMPLE_RATE,
} from './config';
import Contact from './contact';
import FeatureTabs from './feature-tabs';
import Newsletter from './newsletter';
import Payments from './payments';
import Video from './video';
import Slider from './slider';
import Related from './related';
import Course from './course';
import Recommendations from './recommendations';
import AllCourses from './all-courses';
import Checkout from './checkout';
import Toast from './toast';
import { payment } from './checkout';  

const init = () => {
  Sentry.init({
    debug: SENTRY_DEBUG_MODE,
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
    integrations: [new Integrations.BrowserTracing()],
    maxBreadcrumbs: 50,
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
  });

  Auth.init();
  Contact.init();
  FeatureTabs.init();
  Newsletter.init();
  Checkout.init();
  Payments.init();
  Video.init();
  Slider.init();
  Recommendations.init();
  AllCourses.init();
  Course.init();
  Related.init();
  Toast.init();

  document.getElementById('toggle-navigation')
      .addEventListener('click', toggleNav, false);

  setupGlobalListeners();
  prefillSearchQuery();
  checkQueryParams();
  initSearchField();
  checkSubscription();
};

async function checkSubscription() {
  try {
    const res = await payment.getSubscriptionsStatus();
    const subscriptionStatusElement = document.getElementById('subscription-status');
    const subscriptionUserIdStatusElement = document.getElementById('user-id');

    if (subscriptionStatusElement) {
      subscriptionStatusElement.textContent = res.user.has_subscription ? "true" : "false";
    } 
    if (subscriptionUserIdStatusElement) {
      subscriptionUserIdStatusElement.textContent = res.user.id;
    } 
  } catch (error) {
    console.error('Error checking subscription:', error);
  }
};

function checkQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('sign-in')) {
    // trigger sign-in pop up
    let flow = null;
    if (urlParams.has('return-url')) {
      // set flow to use returnUrl if exists
      const returnUrlDecoded = decodeURI(urlParams.get('return-url'));
      window.sessionStorage.setItem('returnUrl', returnUrlDecoded);
      flow = 'returnUrl';
    }
    Auth.openSignInOverlay(null, {flow});
  }
}

function toggleNav(event) {
  // Don't follow the link
  if (event) {
    event.preventDefault();
  }
  document.getElementById('toggle-navigation').classList.toggle('is-active');
  document.getElementById('mobile-nav').classList.toggle('is-hidden');
  // document.getElementById('header').classList.toggle('is-shy');
  document.body.classList.toggle('u-vp-no-scroll');
}

function prefillSearchQuery() {
  const urlParams = new URLSearchParams(window.location.search);
  const globalSearchEl = document.getElementById('global-search');
  if (urlParams.has('query') && globalSearchEl) {
    globalSearchEl.querySelector('input').value = decodeURIComponent(urlParams.get('query'));
  }
}

function setupGlobalListeners() {
  document.querySelectorAll('.js-close-overlay').forEach((el) => el.addEventListener('click', closeOverlay));
  const courseSummaryImgEl = document.getElementById('course-summary-img');
  const courseSummaryListEl = document.getElementById('course-summary-list');

  if (courseSummaryImgEl && courseSummaryListEl) {
    courseSummaryImgEl.addEventListener('load', (event) => courseSummaryListEl.style.maxHeight = `${event.currentTarget.height}px`);
  }

  window.addEventListener('hashchange', hashChangeHandler);
}

const closeOverlay = (event) => {
  event.preventDefault();
  event.currentTarget.parentNode.classList.add('is-hidden');
};

const hashChangeHandler = () => {
  switch (window.location.hash) {
    case '#contact':
      Contact.openContactForm();
      break;
    case '#gift':
      Payments.openGiftOverlay();
      break;
    case '#newsletter':
      Newsletter.openOverlay();
      break;
    case '#purchase':
      Payments.openPurchaseOverlay();
      break;
    case '#signin':
      Auth.openSignInOverlay();
      break;
    case '#signup':
      Auth.openSignUpOverlay();
      break;
    default:
      return;
  }
  // clear hash after use
  history.pushState('', document.title, window.location.pathname + window.location.search);
};

const initSearchField = () => {
  const searchForm = document.getElementById('global-search');
  const searchBtn = document.getElementById('search-btn');
  const resetBtn = document.getElementById('reset-search-btn');
  const input = document.getElementById('search-input');

  if (input.value === '') {
    resetBtn.classList.add('hidden');
  } else {
    resetBtn.classList.remove('hidden');
  }

  searchBtn.addEventListener('click', () => {
    if (input.value === '') return;

    searchForm.dispatchEvent(new Event('submit'));
  });
  resetBtn.addEventListener('click', () => {
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has('query') || urlParams.get('query') === '') {
      input.value = '';
      resetBtn.classList.add('hidden');
      return;
    }
    urlParams.delete('query');

    window.location.search = urlParams.toString();
  });
  input.addEventListener('input', () => {
    if (input.value === '') {
      resetBtn.classList.add('hidden');
    } else {
      resetBtn.classList.remove('hidden');
    }
  });
};

document.addEventListener('DOMContentLoaded', init);
